import {
  DATA_CONNECTOR_UPDATE_EXTERNAL_DATABASE_FOR_DIRECTUS_BEGIN,
  DATA_CONNECTOR_UPDATE_EXTERNAL_DATABASE_FOR_DIRECTUS_SUCCESS,
  DATA_CONNECTOR_UPDATE_EXTERNAL_DATABASE_FOR_DIRECTUS_FAILURE,
  DATA_CONNECTOR_UPDATE_EXTERNAL_DATABASE_FOR_DIRECTUS_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
export function updateExternalDatabaseForDirectus(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_UPDATE_EXTERNAL_DATABASE_FOR_DIRECTUS_BEGIN,
    });
    const {
      projectId,
      version,
      externalDbUuid,
      newResult,
      collectionName,
      selectedPrimaryKey,
      collectionTitle,
    } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.put(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/directus/${externalDbUuid}`,
        { fields: newResult, collectionName: collectionName, selectedPrimaryKey, collectionTitle },
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_UPDATE_EXTERNAL_DATABASE_FOR_DIRECTUS_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_UPDATE_EXTERNAL_DATABASE_FOR_DIRECTUS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUpdateExternalDatabaseForDirectusError() {
  return {
    type: DATA_CONNECTOR_UPDATE_EXTERNAL_DATABASE_FOR_DIRECTUS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_UPDATE_EXTERNAL_DATABASE_FOR_DIRECTUS_BEGIN:
      return {
        ...state,
        updateExternalDatabaseForDirectusPending: true,
        updateExternalDatabaseForDirectusError: null,
      };

    case DATA_CONNECTOR_UPDATE_EXTERNAL_DATABASE_FOR_DIRECTUS_SUCCESS:
      return {
        ...state,
        updateExternalDatabaseForDirectusPending: false,
        updateExternalDatabaseForDirectusError: null,
      };

    case DATA_CONNECTOR_UPDATE_EXTERNAL_DATABASE_FOR_DIRECTUS_FAILURE:
      return {
        ...state,
        updateExternalDatabaseForDirectusPending: false,
        updateExternalDatabaseForDirectusError: action.data.error,
      };

    case DATA_CONNECTOR_UPDATE_EXTERNAL_DATABASE_FOR_DIRECTUS_DISMISS_ERROR:
      return {
        ...state,
        updateExternalDatabaseForDirectusError: null,
      };

    default:
      return state;
  }
}
